/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { IndividualPaymentParcelSaveViewModel } from "../types/IndividualPaymentParcelSaveViewModel.ts";

export const individualPaymentParcelSaveViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  courseFinancialPersonId: z.optional(z.number().int()),
  numberParcel: z.optional(z.number().int()),
  typeId: z.optional(z.number().int()),
  statusId: z.optional(z.number().int()),
  paymentMethod: z.optional(z.number().int()),
  total: z.optional(z.number()),
  expirationDate: z.optional(z.string().datetime()),
  fine: z.number().nullish(),
  discountPunctualPercentage: z.number().nullish(),
  totalDiscount: z.optional(z.number()),
  retroactiveDiscount: z.optional(z.number()),
  observation: z.string().nullish(),
  message: z.string().nullish(),
  invoiceNumber: z.string().nullish(),
  invoiceIssueDate: z.string().datetime().nullish(),
  serial: z.number().int().nullish(),
  multiple: z.optional(z.boolean()),
  amountOfParcel: z.optional(z.number().int()),
  removePunctualDiscount: z.optional(z.boolean()),
  resetExtendedExpiration: z.optional(z.boolean()),
  fractionOfParcel: z.number().nullish(),
}) as unknown as ToZod<IndividualPaymentParcelSaveViewModel>;
